export const getLocaleTime = (date: Date, timeZone: string) => {
  const localeTime = date.toLocaleTimeString("fr-FR", { timeZone });
  const values = localeTime.split(":");

  return {
    hours: +values[0],
    minutes: +values[1],
    seconds: +values[2],
  };
};
